import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJobPending = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3752 1.75V3.5C15.2164 3.9725 17.9377 7.46375 17.4652 11.305C17.272 12.8529 16.5683 14.2921 15.4653 15.3951C14.3623 16.4981 12.9231 17.2019 11.3752 17.395V19.145C16.1877 18.62 19.6439 14.2975 19.1189 9.49375C18.6639 5.41625 15.4527 2.1875 11.3752 1.75ZM9.6252 1.75C7.9102 1.9075 6.29145 2.58125 4.96145 3.675L6.2127 5.0225C7.1927 4.235 8.37395 3.7275 9.6252 3.5525V1.75ZM3.7277 4.96125C2.63016 6.28683 1.95643 7.91172 1.79395 9.625H3.54395C3.7102 8.3825 4.2002 7.20125 4.97895 6.2125L3.7277 4.96125ZM1.8027 11.375C1.9777 13.09 2.65145 14.7087 3.73645 16.0387L4.97895 14.7875C4.20626 13.7984 3.71366 12.6198 3.5527 11.375H1.8027ZM6.1777 16.0738L4.96145 17.2725C6.28688 18.3774 7.90956 19.0654 9.6252 19.25V17.5C8.38042 17.339 7.2018 16.8464 6.2127 16.0738H6.1777Z",
		fill: "#A7A8A9"
	})
});
export default SvgJobPending;
